import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Tooltip,
    Icon,
} from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

function PartnerCodeField({
    label = 'Partner Code (Optional)',
    field,
    form,
    ...inputProps
}) {
    const isInvalid = Boolean(
        form.errors[field.name] && form.touched[field.name],
    );

    return (
        <FormControl isInvalid={isInvalid}>
            <FormLabel htmlFor={field.name} display="flex" alignItems="center">
                {label}
                <Tooltip
                    label="If you are using a partner to assist in your onboarding, please enter their code below. If you don't have one you can leave it blank."
                    fontSize="sm"
                    placement="top">
                    <Icon as={InfoIcon} ml={2} boxSize={3} />
                </Tooltip>
            </FormLabel>
            <Input
                {...field}
                id={field.name}
                placeholder="Enter partner code"
                type="text"
                borderColor="gray.300"
                _placeholder={{ color: 'gray.400' }}
                {...inputProps}
            />
            <FormErrorMessage fontSize="sm" mt={1}>
                {form.errors[field.name]}
            </FormErrorMessage>
        </FormControl>
    );
}

export { PartnerCodeField };
